import classNames from 'classnames'
import * as React from 'react'
import {useCallback} from 'react'

import type {BuildTypeId} from '../../../../../types'
import {useBuildsClassName} from '../../../../common/Builds/Builds'
import BuildTypes from '../../../../common/NestedSubprojectsAndBuildTypes/BuildTypes/BuildTypes.container'
import {BuildTypesContext} from '../../../../common/NestedSubprojectsAndBuildTypes/BuildTypes/BuildTypesContext'

import type {OwnProps} from './BuildsByBuildType.types'
import BuildTypeLine from './BuildTypeLine/BuildTypeLine'

import styles from './BuildsByBuildType.css'

export default function BuildsByBuildType({projectId, onlyFavorites = false, nested}: OwnProps) {
  const buildsClassName = classNames(styles.container, useBuildsClassName())

  const nestedRender = useCallback(
    (buildTypeId: BuildTypeId, archivedProject: boolean, isFavorite: boolean) => (
      <BuildTypeLine
        buildTypeId={buildTypeId}
        archivedProject={archivedProject}
        isFavorite={isFavorite}
        nested={nested}
      />
    ),
    [nested],
  )

  return (
    <BuildTypesContext.Provider value={nestedRender}>
      <BuildTypes
        projectId={projectId}
        onlyFavorites={onlyFavorites}
        gridClassName={buildsClassName}
      />
    </BuildTypesContext.Provider>
  )
}
